<template>
  <div class="grouped__wrapper">
    <message
      v-for="(m, i) in messages"
      :key="m.message_ts"
      :message="m"
      :message-thread-id="messageThreadId"
      :is-feed="isFeed"
      :is-self="isSelf"
      is-same-as-prev
      is-in-group
      :is-last="messages.length - 1 === i"
      :is-first="i === 0"
      :group-key="groupKey"
      @openImage="
        ({ imageId }) =>
          $emit('openImage', { imageId, groupId: lightboxGroupKey })
      "
    />
  </div>
</template>

<script>
import { isPresent } from "@/lib/utils"
import { LIGHT_BOX_KEY } from "@/lib/constants"

export default {
  components: {
    Message: () => import("@/components/message-thread/Message")
  },

  props: {
    message: { type: Object, required: true },
    isFeed: { type: Boolean, default: false },
    isSelf: { type: Boolean, default: false }
  },

  computed: {
    messages() {
      return isPresent(this.message) && isPresent(this.message.messages)
        ? this.message.messages
        : []
    },

    messageThreadId() {
      return this.message?.message_thread_id
    },

    lightboxGroupKey() {
      return `${LIGHT_BOX_KEY}-${this.groupKey}`
    },

    groupKey() {
      return `${this.message?.message_ts || this._uid}`
    }
  }
}
</script>
